import { IRetryPolicy, RetryContext } from '@microsoft/signalr';

export class LoadOneReconnectPolicy implements IRetryPolicy {
    public nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
        return Math.min(retryContext.previousRetryCount * 1000, 20000);
    }
}